import { AccountLocKey } from '@betty/account/state';

type Section = {
  headerKey: AccountLocKey;
  textKey: AccountLocKey;
};

const privacyPolicySections: Section[] = [
  { headerKey: 'whoHeader', textKey: 'whoWeAreText' },
  { headerKey: 'whatIsPrivacyHeader', textKey: 'whatIsPrivacyText' },
  { headerKey: 'inTouchHeader', textKey: 'inTouchText' },
  { headerKey: 'storingPersonalHeader', textKey: 'storingPersonalText' },
  { headerKey: 'processPersonalHeader', textKey: 'processPersonalText' },
  { headerKey: 'yourInfoHeader', textKey: 'yourInfoText' },
  { headerKey: 'infoWeCollectHeader', textKey: 'infoWeCollectText' },
  { headerKey: 'customerServicesHeader', textKey: 'customerServicesText' },
  { headerKey: 'sharingPersonalHeader', textKey: 'sharingPersonalText' },
  { headerKey: 'controlingPersonalHeader', textKey: 'controlingPersonalText' },
  { headerKey: 'changesPrivacyHeader', textKey: 'changesPrivacyText' },
];

export default privacyPolicySections;
